import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TravelerGroupComponent } from '@dynamic-components/booker-v2/shared/traveler-selector/traveler-group/traveler-group.component';
import { UIModule } from '@shared/ui';
import { JbIncrementerModule } from 'jb-component-library';

const MODULES = [CommonModule, UIModule, JbIncrementerModule];

const DECLARATIONS = [TravelerGroupComponent];

@NgModule({
  imports: [...MODULES, ReactiveFormsModule],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class TravelerGroupModule {}
